/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createAboutPageLayoutStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      minWidth: '100vw',
      minHeight: '100vh',
    },
  }),
);

export { createAboutPageLayoutStyles };
